export default function ArrowDown() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 6.5L8.5 10.5L12.5 6.5"
        stroke="#1A1F1F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
